<template>
  <jade-box
    :title="$t('paymentMethodsTitle')"
    class="flex-1"
    hasPadding
  >
    <template #action>
      <div class="flex items-center gap-1">
        <jade-switch
          @onClick="toogleType"
          name="paymentMethodsSwitch"
          disabledFocus
        />
        <jade-text>Valor em R$</jade-text>
      </div>
    </template>
    <template>
      <dash-card-content-fallback :hasData="hasData">
        <dash-progress-bar
          v-for="item in paymentMethods"
          :key="item.key"
          :value="item.percentage"
          :color="item.color"
          :currency="item.value"
          :show-currency="dataType === dataTypeEnum.VALUE"
        >
          <payment-methods-icons
            v-if="item.leftIcon"
            :icon-name="item.leftIcon.name"
            :tooltip-list="item.leftIcon.tooltip"
            tooltip-id="paymentMothods_info-tippy-left"
          />

          <jade-text>{{ $t(item.name) }}</jade-text>

          <payment-methods-icons
            v-if="item.rightIcon"
            :icon-name="item.rightIcon.name"
            :tooltip-list="item.rightIcon.tooltip"
            :dataType="dataType"
            tooltip-id="paymentMothods_info-tippy-right"
          />
        </dash-progress-bar>
      </dash-card-content-fallback>
    </template>
  </jade-box>
</template>

<script>
import { JadeBox, JadeSwitch, JadeText } from '@jade'

import Amplitude from '@/amplitude-events/resume.amplitude'
import PaymentMethodsIcons from '@/components/project/globals/PaymentMethodsIcons/index.vue'
import { DASHBOARD_DATA_TYPE_ENUM } from '@/enums/dash-progress-data-type.enum'
import MathManager from '@/utils/math-manager.utils'

import DashProgressBar from '../components/DashProgressBar/index.vue'
import DashCardContentFallback from '../components/DashCardContentFallback/index.vue'
import DashProgressManager from '../dash-progress.manager'
import PaymentMethodsManager from './payment-methods.manager'

export default {
  name: 'PaymentMethods',

  components: {
    JadeBox,
    JadeText,
    JadeSwitch,

    DashProgressBar,
    DashCardContentFallback,

    PaymentMethodsIcons
  },

  data () {
    return {
      dataTypeEnum: DASHBOARD_DATA_TYPE_ENUM,
      dataType: DASHBOARD_DATA_TYPE_ENUM.PERCENTAGE
    }
  },

  props: {
    data: Array
  },

  computed: {
    hasData () {
      return this.paymentMethods.length > 0
    },
    total () {
      return MathManager.sumByKeys(this.data)?.quantity ?? 0
    },
    paymentMethods () {
      return new PaymentMethodsManager( //
        new DashProgressManager(
          this.data, //
          this.total
        )
      ).get()
    }
  },

  methods: {
    toogleType () {
      this.dataType =
        this.dataType === DASHBOARD_DATA_TYPE_ENUM.PERCENTAGE
          ? DASHBOARD_DATA_TYPE_ENUM.VALUE
          : DASHBOARD_DATA_TYPE_ENUM.PERCENTAGE

      Amplitude.events.filters.paymentMethodsTypeValueChanged({
        type: this.dataType
      })
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "paymentMethodsTitle": "Formas de pagamento mais utilizadas",
      "paymentMethodsDescription": "Top 5 formas de pagamento mais utilizadas na criação das cobranças.",
      "disclaimer": "Não inclui cobranças em processamento.",
      "payment-method": {
        "boleto": "Boleto",
        "credit-card": "Cartão de crédito",
        "bank-transfer": "Transferência",
        "debit": "Débito",
        "private-label": "Private Label",
        "cash": "Dinheiro",
        "safety-pay": "Safety Pay",
        "voucher": "Voucher",
        "pix": "Pix",
        "others": "Outros"
      }
    },
    "en-US": {
      "paymentMethodsTitle": "Top Payment Methods",
      "paymentMethodsDescription": "Top 5 Payment Methods for charge creation.",
      "disclaimer": "Doesn't include processing charges.",
      "payment-method": {
        "all": "All",
        "boleto": "Boleto",
        "credit-card": "Credit Card",
        "bank-transfer": "Bank Transfer",
        "debit": "Debit",
        "private-label": "Private Label",
        "cash": "Cash",
        "safety-pay": "Safety Pay",
        "voucher": "Voucher",
        "pix": "Pix",
        "others": "others"
      }
    }

  }
  </i18n>
